import {
	AttentionHeader,
	AttentionLabel,
	AttentionRail,
	InsightContent,
	InsightList,
	InsightRow,
	InsightDescription,
	InsightTitle,
	StatusPill,
} from "../styles";

const AttentionPanel = ({ items }) => {
	return (
		<AttentionRail>
			<AttentionHeader>
				<AttentionLabel>Atención</AttentionLabel>
			</AttentionHeader>

			<InsightList>
				{items.map(item => (
					<InsightRow key={item.id} $tone={item.tone}>
						<InsightContent>
							<InsightTitle>{item.title}</InsightTitle>
							{item.description ? (
								<InsightDescription>{item.description}</InsightDescription>
							) : null}
						</InsightContent>
						<StatusPill $variant={item.pillVariant}>{item.pill}</StatusPill>
					</InsightRow>
				))}
			</InsightList>
		</AttentionRail>
	);
};

export default AttentionPanel;
